import {
  Button,
  useTheme
} from '@mui/material';
import {
  useNavigate,
  useParams
} from 'react-router-dom';

import { useAccessState } from 'modules/common';
import { CustomIcon } from 'modules/components/layer00';
import {
  SaveMilestoneModal,
  RemoveMilestoneModal
} from 'modules/components/layer17';
import { ActivityHeaderSectionWithFIlterLayout } from 'modules/components/layer32';
import React, { useState } from 'react';

import * as ds from './dataService';



export type ProjectMilestoneHeaderSectionProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ProjectMilestoneHeaderSectionProps) => {
  const params = useParams();

  const { data } = ds.useQuery(params.milestoneId ?? '');
  return (
    <ActivityHeaderSectionWithFIlterLayout.FC
      filterRow={(<></>)}
      actionButtons={<ActionButtonsGroup id={data.id} />}
      title={data.title !== '' ? data.title : 'Milestone'}
      subtitle={data.description !== '' ? data.description : 'Milestone'}
      backButton={true}
    />
  );
};


type ActionButtonsGroup = {
  id: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
const ActionButtonsGroup = (props: ActionButtonsGroup) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const [
    isDeleteVisible,
    setIsDeleteVisible
  ] = useState(false);
  const params = useParams();
  const access = useAccessState('Milestone');

  const navigate = useNavigate();

  return (
    <>
      {isVisible && (
        <SaveMilestoneModal.FC
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
          id={params.milestoneId ?? ''}
        />
      )}
      {isDeleteVisible && (
        <RemoveMilestoneModal.FC
          isVisible={isDeleteVisible}
          handleClose={() => {
            setIsDeleteVisible(() => false);
            navigate('..');
          }}
          id={params.milestoneId ?? ''}
        />
      )}
      <Button
        variant='contained'
        color='primary'
        disabled={!access.update}
        onClick={() => setIsVisible(() => true)}
        startIcon={(
          <CustomIcon.large.FC
            icon='EDIT'
            stroke={theme.palette.primary.contrastText}
          />
        )}
      >
        Edit
      </Button>
      <Button
        variant='outlined'
        color='error'
        disabled={!access.delete}
        onClick={() => {
          setIsDeleteVisible(() => true);
        }}
        startIcon={(
          <CustomIcon.large.FC
            icon='DELETE'
            stroke={theme.palette.error.main}
          />
        )}
      >
        Remove Milestone
      </Button>

    </>
  );
};

